import Vue from 'vue'
import axios from 'axios'

const WEB_SERVICE_URL = process.env.VUE_APP_WEB_SERVICE_URL
const AUTH_SERVICE_URL = process.env.VUE_APP_AUTH_SERVICE_URL

const config = {
  login: {
    url: `${WEB_SERVICE_URL}/auth/login`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    csrf: true
  },
  loginV2: {
    url: `${AUTH_SERVICE_URL}/token`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  refreshV2: {
    url: `${AUTH_SERVICE_URL}/refresh`,
    method: 'post'
  },
  getCSRF: {
    url: `${WEB_SERVICE_URL}/auth/token`
  },
  recaptcha: {
    url: `${AUTH_SERVICE_URL}/recaptcha`
  },
  register: {
    url: `${AUTH_SERVICE_URL}/autoreg`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  confirmRegister: {
    url: `${AUTH_SERVICE_URL}/autoreg/confirm`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  restore: {
    url: `${WEB_SERVICE_URL}/index/pwrecovery`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    csrf: true
  }
}

let handlers = {
  success: [],
  error: []
}

let api = {
  addHandler (handler, type) {
    handlers[type].push(handler)
    return this
  },
  onSuccess (response) {
    let breakChain = false

    handlers.success.forEach((handler) => {
      if (handler(response) === false) {
        breakChain = true
      }
    })

    return breakChain ? (new Promise(() => {})) : response
  },
  onError (error) {
    let breakChain = false

    handlers.error.forEach((handler) => {
      if (handler(error) === false) {
        breakChain = true
      }
    })

    if (breakChain) {
      return new Promise(() => {})
    } else {
      throw error
    }
  },
  csrf: null,
  setCSRF (data) {
    this.csrf = data.csrf_token
  },
  token: null,
  setToken (data) {
    this.token = data.access_token
    sessionStorage.setItem('token', this.token)
    Vue.localStorage.set('user_id', data.user_id)
    Vue.localStorage.set('expires_at', data.expires_at)
    Vue.localStorage.set('refresh_token', data.refresh_token)
    sessionStorage.setItem('issued_at', Date.now())
  }
}

Object.keys(config).forEach(function (method) {
  let endpoint = config[method]

  api[method] = function (data, params = {}) {
    let config = Object.assign({}, params, {
      url: endpoint.url,
      method: endpoint.method || 'get',
      headers: endpoint.headers || {},
      csrf: endpoint.csrf || false
    })

    if (data) {
      Object.keys(data).forEach((item) => {
        config.url = config.url.replace('{' + item + '}', () => {
          let value = data[item]
          delete data[item]
          return value
        })
      })
    }

    if (config.method === 'get') {
      config.params = data
    } else {
      if (data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        let query = new URLSearchParams()
        Object.keys(data).forEach(function (key) {
          query.append(key, data[key])
        })
        if (config.csrf) {
          query.append('csrf_token', api.csrf)
        }
        config.data = query
      } else {
        config.data = data
      }
    }

    return request(config)
  }
})

function request (params) {
  return axios.request(params).then(api.onSuccess).catch(api.onError)
}

export default api
